import React from "react";
import { ToastContainer, toast as toastifyToast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Toast.css";

export function ToastProvider() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable={false}
      theme="colored"
      icon={false}
      toastClassName="ui-toast"
      className="ui-toast-container"
    />
  );
}

/* Wrapper that emits well-styled toasts. Pass strings or React nodes. */
export const toast = {
  success: (msg, opts) => toastifyToast.success(msg, opts),
  error: (msg, opts) => toastifyToast.error(msg, opts),
  warn: (msg, opts) => toastifyToast.warn(msg, opts),
  info: (msg, opts) => toastifyToast.info(msg, opts),
  default: (msg, opts) => toastifyToast(msg, opts),
};
